import R from 'ramda';
import semaphoretemplate from './semaphore.tpl.html';

export class Semaphore {
  constructor($scope) {
    Object.assign(this, {
      $scope,
    });
  }

  $onInit() {
    if (this.mapStatuses) {
      this.mappedStatuses = this.mapStatuses({ statuses: this.statuses });
    } else {
      const statusPairs = R.toPairs(this.statuses);
      this.mappedStatuses = {
        red: statusPairs.length > 0 ? [statusPairs[0][0]] : [],
        yellow: statusPairs.length > 1 ? [statusPairs[1][0]] : [],
        green: statusPairs.length > 2 ? [statusPairs[2][0]] : [],
      };
    }
  }
}

Semaphore.$inject = [
  '$scope',
];

export const semaphore = {
  template: semaphoretemplate,
  controller: Semaphore,
  bindings: {
    activeStatus: '<',
    statuses: '<',
    mapStatuses: '&?',
  },
};
